import { render, staticRenderFns } from "./KChip.vue?vue&type=template&id=16a0c714&"
import script from "./KChip.vue?vue&type=script&lang=js&"
export * from "./KChip.vue?vue&type=script&lang=js&"
import style0 from "./KChip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports